// Main script file for Pet Breed Matcher
// Handles UI interactions and quiz logic
// Load breed data from JSON files



import { dogBreeds, catBreeds, quizQuestions, loadBreedData } from './data.js';
import BreedMatcher from './breed_matcher.js';



console.log('Breed Matcher rwar:', BreedMatcher);


// DOM Elements
const startScreen = document.getElementById('start-screen');
const questionScreen = document.getElementById('question-screen');
const resultsScreen = document.getElementById('results-screen');
const startButton = document.getElementById('start-button');
const prevButton = document.getElementById('prev-button');
const nextButton = document.getElementById('next-button');
const questionContainer = document.getElementById('question-container');
const progressFill = document.getElementById('progress-fill');
const questionCounter = document.getElementById('question-counter');
const primaryMatch = document.getElementById('primary-match');
const additionalMatches = document.getElementById('additional-matches');
const restartButton = document.getElementById('restart-button');

// Templates
const petTypeTemplate = document.getElementById('pet-type-template');
const optionButtonsTemplate = document.getElementById('option-buttons-template');
const matchCardTemplate = document.getElementById('match-card-template');

// Quiz state
let currentQuestionIndex = 0;
let questions = [];
let userAnswers = {};
let selectedPetType = null;
let breedMatcher = null;

// Initialize the quiz
async function initQuiz() {
    // Load breed data
    const dataLoaded = await loadBreedData();
    if (!dataLoaded) {
        alert('Error loading breed data. Please refresh the page and try again.');
        return;
    }
    
    // Initialize breed matcher
    breedMatcher = new BreedMatcher(dogBreeds, catBreeds);
    
    // Set up event listeners
    startButton.addEventListener('click', startQuiz);
    prevButton.addEventListener('click', goToPreviousQuestion);
    nextButton.addEventListener('click', goToNextQuestion);
    restartButton.addEventListener('click', restartQuiz);
    
    // Add event listeners for learn more buttons in results
    document.addEventListener('click', function(e) {
        if (e.target && e.target.classList.contains('learn-more-btn')) {
            const additionalInfo = e.target.nextElementSibling;
            additionalInfo.classList.toggle('active');
            e.target.textContent = additionalInfo.classList.contains('active') ? 'Show Less' : 'Learn More';
        }
    });
}

// Start the quiz
function startQuiz() {
    startScreen.classList.remove('active');
    questionScreen.classList.add('active');
    
    // Start with pet type question
    questions = [quizQuestions.petType];
    renderQuestion(0);
}

// Render the current question
function renderQuestion(index) {
    const question = questions[index];
    questionContainer.innerHTML = '';
    
    if (question.type === 'petType') {
        // Clone the pet type template
        const petTypeQuestion = petTypeTemplate.content.cloneNode(true);
        
        // Add event listeners to option cards
        const optionCards = petTypeQuestion.querySelectorAll('.option-card');
        optionCards.forEach(card => {
            card.addEventListener('click', () => {
                // Remove selected class from all cards
                optionCards.forEach(c => c.classList.remove('selected'));
                // Add selected class to clicked card
                card.classList.add('selected');
                // Store the answer
                const value = card.getAttribute('data-value');
                userAnswers[question.id] = value;
                selectedPetType = value;
                
                // Enable next button
                nextButton.disabled = false;
            });
            
            // Pre-select if answer exists
            if (userAnswers[question.id] === card.getAttribute('data-value')) {
                card.classList.add('selected');
            }
        });
        
        questionContainer.appendChild(petTypeQuestion);
    } else if (question.type === 'option') {
        // Clone the option buttons template
        const optionQuestion = optionButtonsTemplate.content.cloneNode(true);
        
        // Set question text
        optionQuestion.querySelector('#question-text').textContent = question.text;
        
        // Create option buttons
        const optionsContainer = optionQuestion.querySelector('.button-options');
        question.options.forEach(option => {
            const button = document.createElement('button');
            button.className = 'option-button';
            button.textContent = option.text;
            button.setAttribute('data-value', option.value);
            
            // Pre-select if answer exists
            if (userAnswers[question.id] === option.value) {
                button.classList.add('selected');
            }
            
            button.addEventListener('click', () => {
                // Remove selected class from all buttons
                optionsContainer.querySelectorAll('.option-button').forEach(b => b.classList.remove('selected'));
                // Add selected class to clicked button
                button.classList.add('selected');
                // Store the answer
                userAnswers[question.id] = option.value;
                
                // Enable next button
                nextButton.disabled = false;
            });
            
            optionsContainer.appendChild(button);
        });
        
        questionContainer.appendChild(optionQuestion);
    }
    
    // Update progress
    updateProgress();
    
    // Update button states
    prevButton.disabled = index === 0;
    nextButton.disabled = !userAnswers[question.id];
}

// Update progress bar and question counter
function updateProgress() {
    const progress = ((currentQuestionIndex + 1) / questions.length) * 100;
    progressFill.style.width = `${progress}%`;
    questionCounter.textContent = `Question ${currentQuestionIndex + 1}/${questions.length}`;
}

// Go to the previous question
function goToPreviousQuestion() {
    if (currentQuestionIndex > 0) {
        currentQuestionIndex--;
        renderQuestion(currentQuestionIndex);
    }
}

// Go to the next question
function goToNextQuestion() {
    // If this is the pet type question, build the rest of the questions
    if (currentQuestionIndex === 0 && questions.length === 1) {
        buildQuestionList();
    }
    
    if (currentQuestionIndex < questions.length - 1) {
        currentQuestionIndex++;
        renderQuestion(currentQuestionIndex);
    } else {
        // Last question, show results
        showResults();
    }
}

// Build the question list based on pet type selection
function buildQuestionList() {
    // Add common questions
    questions = questions.concat(quizQuestions.common);
    
    // Add pet-specific questions
    if (selectedPetType === 'dog') {
        questions = questions.concat(quizQuestions.dog);
    } else if (selectedPetType === 'cat') {
        questions = questions.concat(quizQuestions.cat);
    }
}

// Show the results screen
function showResults() {
    // Set pet type in breed matcher
    breedMatcher.setPetType(selectedPetType);
    
    // Set all answers in breed matcher
    for (const [questionId, answer] of Object.entries(userAnswers)) {
        breedMatcher.setAnswer(questionId, answer);
    }
    
    // Get top matches
    const topMatches = breedMatcher.getTopMatches(5);
    
    // Show results screen
    questionScreen.classList.remove('active');
    resultsScreen.classList.add('active');
    
    // Render primary match
    renderPrimaryMatch(topMatches[0]);
    
    // Render additional matches
    renderAdditionalMatches(topMatches.slice(1));
}

// Render the primary match
function renderPrimaryMatch(breed) {
    primaryMatch.innerHTML = '';
    
    const matchCard = matchCardTemplate.content.cloneNode(true);
    
    // Set breed image
    const imageElement = matchCard.querySelector('.match-image img');
    imageElement.src = `images/${breed.image}`;
    imageElement.alt = breed.name;
    
    // Set breed name and match percentage
    matchCard.querySelector('.breed-name').textContent = breed.name;
    matchCard.querySelector('.match-percentage').textContent = `${breed.matchScore}% Match`;
    
    // Set breed description
    matchCard.querySelector('.breed-description').textContent = breed.description;
    
    // Add characteristics
    const characteristicsContainer = matchCard.querySelector('.breed-characteristics');
    addCharacteristics(characteristicsContainer, breed);
    
    // Add additional info
    const additionalInfo = matchCard.querySelector('.additional-info');
    addAdditionalInfo(additionalInfo, breed);
    
    primaryMatch.appendChild(matchCard);
}

// Render additional matches
function renderAdditionalMatches(breeds) {
    additionalMatches.innerHTML = '';
    
    breeds.forEach(breed => {
        const matchCard = matchCardTemplate.content.cloneNode(true);
        
        // Set breed image
        const imageElement = matchCard.querySelector('.match-image img');
        imageElement.src = `images/${breed.image}`;
        imageElement.alt = breed.name;
        
        // Set breed name and match percentage
        matchCard.querySelector('.breed-name').textContent = breed.name;
        matchCard.querySelector('.match-percentage').textContent = `${breed.matchScore}% Match`;
        
        // Set breed description
        matchCard.querySelector('.breed-description').textContent = breed.description;
        
        // Add characteristics
        const characteristicsContainer = matchCard.querySelector('.breed-characteristics');
        addCharacteristics(characteristicsContainer, breed);
        
        // Add additional info
        const additionalInfo = matchCard.querySelector('.additional-info');
        addAdditionalInfo(additionalInfo, breed);
        
        additionalMatches.appendChild(matchCard);
    });
}

// Add characteristics to the match card
function addCharacteristics(container, breed) {
    // Add size
    addCharacteristic(container, 'Size', breed.size);
    
    // Add energy level
    addCharacteristic(container, 'Energy', breed.energy_level);
    
    // Add shedding
    addCharacteristic(container, 'Shedding', breed.shedding);
    
    // Add pet-specific characteristics
    if (selectedPetType === 'dog') {
        addCharacteristic(container, 'Barking', breed.barking_tendency);
    } else {
        addCharacteristic(container, 'Vocalization', breed.vocalization);
    }
}

// Add a single characteristic
function addCharacteristic(container, label, value) {
    if (value) {
        const characteristic = document.createElement('div');
        characteristic.className = 'characteristic';
        characteristic.textContent = `${label}: ${value}`;
        container.appendChild(characteristic);
    }
}

// Add additional info to the match card
function addAdditionalInfo(container, breed) {
    // Create info sections
    const sections = [
        { label: 'Weight', value: breed.weight },
        { label: 'Coat Type', value: breed.coat_type },
        { label: 'Grooming Needs', value: breed.grooming_needs },
        { label: 'Exercise Needs', value: breed.exercise_needs },
        { label: 'Temperament', value: breed.temperament },
        { label: 'Lifespan', value: breed.lifespan }
    ];
    
    // Add each section if it has a value
    sections.forEach(section => {
        if (section.value) {
            const sectionElement = document.createElement('div');
            sectionElement.className = 'info-section';
            
            const labelElement = document.createElement('strong');
            labelElement.textContent = `${section.label}: `;
            
            const valueElement = document.createElement('span');
            valueElement.textContent = section.value;
            
            sectionElement.appendChild(labelElement);
            sectionElement.appendChild(valueElement);
            container.appendChild(sectionElement);
        }
    });
}

// Restart the quiz
function restartQuiz() {
    // Reset quiz state
    currentQuestionIndex = 0;
    questions = [];
    userAnswers = {};
    selectedPetType = null;
    
    // Show start screen
    resultsScreen.classList.remove('active');
    startScreen.classList.add('active');
}





// Initialize the quiz when the page loads
document.addEventListener('DOMContentLoaded', initQuiz);
